export interface FooterLink {
  label: string;
  href: string;
  external?: boolean;
}


export const TOP_BAR_LINKS: FooterLink[] = [
  { label: "درباره ما", href: "/about-us" },
  // { label: "قوانین و مقررات", href: "/terms" },
  { label: "قوانین و مقررات", href: "/terms" },
  // { label: "سوالات متداول", href: "/faq" },
  { label: "دریافت اپلیکیشن های ایده نما", href: "/apps" },
];

export const MIDDLE_NAV_LINKS: FooterLink[] = [
  { label: "خانه", href: "/" },
  // { label: "تبلیغات", href: "/ads" },
  // { label: "سوالات متداول", href: "/faq" },
  // { label: "همکاری با ایده نما", href: "/cooperation" },
  { label: "قوانین و مقررات", href: "/terms" },
];

export const STORE_BADGES = [
  { label: "Myket", href: "https://myket.ir", letter: "M" },
  { label: "Bazaar", href: "https://cafebazaar.ir", letter: "B" },
  // { label: "Sibapp", href: "https://sibapp.com", letter: "M" },
];
